import { render, staticRenderFns } from "./resize_heatmap_btn.vue?vue&type=template&id=206f4631&scoped=true&lang=pug&"
import script from "./resize_heatmap_btn.vue?vue&type=script&lang=js&"
export * from "./resize_heatmap_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f4631",
  null
  
)

export default component.exports